 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"runtime": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"common":"common","modules-admin-cancelled-details-cancelled-details-module":"modules-admin-cancelled-details-cancelled-details-module","modules-admin-customer-details-customer-details-module":"modules-admin-customer-details-customer-details-module","modules-admin-delivery-details-delivery-details-module":"modules-admin-delivery-details-delivery-details-module","modules-admin-leads-leads-module":"modules-admin-leads-leads-module","modules-admin-waiting-cod-waiting-cod-module":"modules-admin-waiting-cod-waiting-cod-module","modules-admin-waiting-dispatch-waiting-dispatch-module":"modules-admin-waiting-dispatch-waiting-dispatch-module","modules-admin-waiting-payments-waiting-payments-module":"modules-admin-waiting-payments-waiting-payments-module","default~modules-admin-catalog-catalog-module~modules-admin-cms-cms-module~modules-admin-contest-cont~c79e396c":"default~modules-admin-catalog-catalog-module~modules-admin-cms-cms-module~modules-admin-contest-cont~c79e396c","modules-admin-track-order-track-order-module":"modules-admin-track-order-track-order-module","default~modules-admin-catalog-catalog-module~modules-admin-cms-cms-module~modules-admin-e-commerce-p~ceccd33e":"default~modules-admin-catalog-catalog-module~modules-admin-cms-cms-module~modules-admin-e-commerce-p~ceccd33e","default~modules-admin-catalog-catalog-module~modules-admin-e-commerce-product-e-commerce-product-mod~6f3241a2":"default~modules-admin-catalog-catalog-module~modules-admin-e-commerce-product-e-commerce-product-mod~6f3241a2","default~modules-admin-catalog-catalog-module~modules-admin-e-commerce-product-e-commerce-product-mod~27e283dd":"default~modules-admin-catalog-catalog-module~modules-admin-e-commerce-product-e-commerce-product-mod~27e283dd","modules-admin-e-commerce-product-e-commerce-product-module":"modules-admin-e-commerce-product-e-commerce-product-module","modules-admin-passportsizephoto-passportsizephoto-module":"modules-admin-passportsizephoto-passportsizephoto-module","modules-admin-photo-print-photo-print-module":"modules-admin-photo-print-photo-print-module","default~modules-admin-catalog-catalog-module~modules-admin-photoframe-photoframe-module~modules-admi~1dd31d1c":"default~modules-admin-catalog-catalog-module~modules-admin-photoframe-photoframe-module~modules-admi~1dd31d1c","modules-admin-catalog-catalog-module":"modules-admin-catalog-catalog-module","modules-admin-photoframe-photoframe-module":"modules-admin-photoframe-photoframe-module","modules-admin-selfie-album-selfie-album-module":"modules-admin-selfie-album-selfie-album-module","modules-admin-test-personalized-test-personalized-module":"modules-admin-test-personalized-test-personalized-module","default~modules-admin-cms-cms-module~modules-admin-employee-employee-module~modules-admin-task-manag~79abaee0":"default~modules-admin-cms-cms-module~modules-admin-employee-employee-module~modules-admin-task-manag~79abaee0","default~modules-admin-contest-contest-module~modules-admin-settings-settings-module~modules-admin-ta~6c12155f":"default~modules-admin-contest-contest-module~modules-admin-settings-settings-module~modules-admin-ta~6c12155f","modules-admin-task-manager-task-manager-module":"modules-admin-task-manager-task-manager-module","default~modules-admin-sessions-sessions-module~modules-admin-settings-settings-module~modules-employ~b18f4cd8":"default~modules-admin-sessions-sessions-module~modules-admin-settings-settings-module~modules-employ~b18f4cd8","default~modules-admin-settings-designation-designation-module~modules-admin-settings-settings-module":"default~modules-admin-settings-designation-designation-module~modules-admin-settings-settings-module","modules-admin-settings-settings-module":"modules-admin-settings-settings-module","modules-admin-refund-refund-module":"modules-admin-refund-refund-module","modules-admin-cms-cms-module":"modules-admin-cms-cms-module","modules-employee-employee-task-manager-employee-task-manager-module":"modules-employee-employee-task-manager-employee-task-manager-module","modules-admin-employee-employee-module":"modules-admin-employee-employee-module","modules-admin-contest-contest-module":"modules-admin-contest-contest-module","modules-admin-management-communication-management-communication-module":"modules-admin-management-communication-management-communication-module","modules-admin-reports-reports-module":"modules-admin-reports-reports-module","default~modules-admin-dashboard-dashboard-module~modules-admin-ticket-ticket-module":"default~modules-admin-dashboard-dashboard-module~modules-admin-ticket-ticket-module","modules-admin-ticket-ticket-module":"modules-admin-ticket-ticket-module","default~modules-admin-dashboard-dashboard-module~modules-employee-dashboard-dashboard-module":"default~modules-admin-dashboard-dashboard-module~modules-employee-dashboard-dashboard-module","modules-employee-dashboard-dashboard-module":"modules-employee-dashboard-dashboard-module","modules-admin-dashboard-dashboard-module":"modules-admin-dashboard-dashboard-module","default~modules-admin-reports-customer-report-customer-report-module~modules-admin-reports-employee-~48a1b291":"default~modules-admin-reports-customer-report-customer-report-module~modules-admin-reports-employee-~48a1b291","modules-admin-reports-customer-report-customer-report-module":"modules-admin-reports-customer-report-customer-report-module","modules-admin-reports-employee-report-employee-report-module":"modules-admin-reports-employee-report-employee-report-module","modules-admin-reports-gst-report-gst-report-module":"modules-admin-reports-gst-report-gst-report-module","modules-admin-reports-payments-payments-module":"modules-admin-reports-payments-payments-module","modules-admin-reports-product-report-product-report-module":"modules-admin-reports-product-report-product-report-module","modules-admin-reports-refund-order-refund-order-module":"modules-admin-reports-refund-order-refund-order-module","modules-admin-reports-review-report-review-report-module":"modules-admin-reports-review-report-review-report-module","modules-admin-reports-sales-report-sales-report-module":"modules-admin-reports-sales-report-sales-report-module","modules-admin-reports-stock-report-stock-report-module":"modules-admin-reports-stock-report-stock-report-module","modules-admin-reports-task-report-task-report-module":"modules-admin-reports-task-report-task-report-module","modules-admin-reports-ticket-report-ticket-report-module":"modules-admin-reports-ticket-report-ticket-report-module","modules-admin-sessions-sessions-module":"modules-admin-sessions-sessions-module","modules-employee-sessions-sessions-module":"modules-employee-sessions-sessions-module","modules-employee-change-password-change-password-module":"modules-employee-change-password-change-password-module","modules-admin-settings-designation-designation-module":"modules-admin-settings-designation-designation-module","firebase-auth":"firebase-auth","firebase-messaging":"firebase-messaging","modules-admin-billing-management-billing-management-module":"modules-admin-billing-management-billing-management-module","modules-admin-commission-transaction-commission-transaction-module":"modules-admin-commission-transaction-commission-transaction-module","modules-admin-notification-notification-module":"modules-admin-notification-notification-module","modules-admin-payment-payment-module":"modules-admin-payment-payment-module","modules-employee-notification-notification-module":"modules-employee-notification-notification-module"}[chunkId]||chunkId) + "-es2015.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
